import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import ChangeHistory from 'components/popup/changeHistory/ChangeHistory';
import StartScreen from './StartScreen';
import DealingsService from 'services/DealingsService';
import {withRouter} from "react-router";
import PositionAndPartsForm from './PositionAndPartsForm';
import Loading from 'components/Loading';
import {connect} from 'react-redux'
import {DemandValidation} from 'constants/DemandValidation';
import {setOpenForm, setOpenImporter, setStepperState} from 'redux/actions'
import ImportScreen from "./ImportScreen";
import reduxStore from 'redux/store'
import DemandService from "services/DemandService";
import validateSection from "services/helpers/validateSection";

const clear = () => {
    DealingsService.clearResources('dealing');
    DealingsService.clearResources('dealingsList');
    reduxStore.dispatch(setOpenForm(undefined));
    reduxStore.dispatch(setOpenImporter(undefined));
}

function Index(
    {
        expanded,
        match,
        dealingsList,
        demandValidation,
        setOpenForm,
        setOpenImporter,
        openForm,
        openImporter,
        demandHeader
    }) {
    const [historyOpen, setHistoryOpen] = useState(false);

    const id = match.params.id;

    useEffect(() => {
        if (expanded) {
            DealingsService.getList(id);
        } else {
            clear();
        }
        return clear
    }, [expanded, id])

    const isOpenImporter = () => {
        return openImporter;
    };

    const isOpenForm = () => {
        const validationObj = demandValidation.find(x => x.section === DemandValidation.DEALINGS);
        if (validationObj === undefined) return openForm;
        if (validationObj.status === 'OK') return true;
        if(demandHeader && demandHeader.hasPlanItems) return true;
        if (dealingsList && dealingsList.dealings && dealingsList.dealings.length > 1) return true;
        return openForm;
    };

    const saveSuccessCallback = () => {
        reduxStore.dispatch(setStepperState());
        DemandService.getValidate(id, false)
    }

    const saveErrorCallback = () => {
        validateSection(DemandValidation.DEALINGS, id, false);
    }

    return (
        <>
            {openForm === null ?
                <Loading/> :
                (isOpenImporter()) ?
                    <ImportScreen id={id}/>
                    :
                    (isOpenForm()) ?
                        <>
                            <PositionAndPartsForm
                                expanded={expanded}
                                section={demandValidation ? demandValidation.find(x => x.section === DemandValidation.DEALINGS) : null}
                                formId="mp_1_dealings"
                                saveSuccessCallback={saveSuccessCallback}
                                saveErrorCallback={saveErrorCallback}
                            />
                            <ChangeHistory
                                open={historyOpen}
                                onClose={() => setHistoryOpen(false)}
                            />
                        </> :
                        <StartScreen onFormOpen={() => setOpenForm(true)} onImporterOpen={() => setOpenImporter(true)}/>
            }
        </>
    )
}

Index.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    dealingsList: state.resources.dealingsList,
    demandValidation: state.resources.demandValidation,
    openForm: state.store.openForm,
    openImporter: state.store.openImporter,
    demandHeader: state.resources.demandHeader,
}), {
    setOpenForm, setOpenImporter
})(withRouter(Index));
